import React from 'react';
import trackLead from '../../trackLead';

const CTA = () => {
  return (
    <div className="bg-gray-100">
      <div className="container">
        <div className="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 flex flex-col justify-center items-center text-center">
          <h2 className="text-2xl md:text-3xl leading-7 md:leading-9 font-bold font-sans text-gray-900 sm:text-4xl sm:leading-relaxed">
            Ready to start collecting feedback?
          </h2>
          <h2 className="text-2xl md:text-3xl leading-7 md:leading-9 font-bold font-sans text-gray-900 sm:text-4xl sm:leading-relaxed mt-2">
            Start your{' '}
            <span className="border-b-4 border-solid border-shop-light-green">
              free trial
            </span>{' '}
            today.
          </h2>
          <a
            href="https://apps.shopify.com/shopfeedback"
            onClick={() => trackLead()}
            className="rounded-full shadow mt-12 inline-flex items-center justify-center px-6 py-2 border border-transparent text-gray-900 leading-5 hover:bg-shop-dark-green hover:text-white font-medium rounded-full bg-shop-light-green focus:outline-none focus:shadow-outline transition duration-300 ease-in-out"
          >
            Get Started Today
          </a>
        </div>
      </div>
    </div>
  );
};

export default CTA;
